export { renderRadio_unstable as renderRadio } from '@fluentui/react-radio';
